import { Navigate, Outlet, useLocation } from 'react-router';
import { useAccount } from '@core/utils/auth';
import { LOGIN_NEXT_PARAM, PATHS } from '@core/routes';

export function RequireAuth() {
  const { user } = useAccount();
  const location = useLocation();

  if (!user) {
    const next = `${location.pathname}${location.search}${location.hash}`;
    const to = next === PATHS.home ? PATHS.login : `${PATHS.login}?${LOGIN_NEXT_PARAM}=${encodeURIComponent(next)}`;
    return <Navigate to={to} replace />;
  }

  return <Outlet />;
}
